
document.addEventListener('DOMContentLoaded', function() {
  
    const menuContainer = document.getElementById('Details-menu-drawer-container');
    const fixedElements = [
      document.querySelector('.fixed-tabmenu'),
      document.getElementById('floatingAddToCart'),
      document.getElementById('BackToTop')
    ].filter(Boolean); // 安全过滤，防止获取不到的元素造成报错
  
    if (!menuContainer) return;
  
    const body = document.body;
    let previousStates = {}; // 保存各浮动元素的显示状态，用于菜单关闭后恢复
  
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(mutation => {
        if (mutation.attributeName === 'class') {
          const isMenuOpen = menuContainer.classList.contains('menu-opening');
  
          if (menuContainer._lastOpenState !== isMenuOpen) {
            if (isMenuOpen) {
              // 菜单打开：隐藏浮动元素并记录其原始状态
              fixedElements.forEach(el => {
                previousStates[el.id] = window.getComputedStyle(el).display;
                el.style.display = 'none';
                el.classList.add('menu-opened');
              });
              body.style.overflow = 'hidden'; // 设置 body overflow 隐藏，防止页面滚动
            } else {
              // 菜单关闭：恢复浮动元素显示状态
              fixedElements.forEach(el => {
                el.classList.remove('menu-opened');
                if (previousStates[el.id] === 'block') {
                  el.style.display = 'block';
                } else {
                  el.style.display = 'none';
                }
              });
              body.style.overflow = ''; // 恢复 body overflow，允许页面滚动
  
              // 菜单关闭后强制刷新所有浮动组件（如返回顶部、加购按钮等）
              if (window.refreshFixedTabVisibility) window.refreshFixedTabVisibility();
              if (window.refreshFloatingBtn) window.refreshFloatingBtn();
              if (window.refreshBackToTop) window.refreshBackToTop();
              
              //if (window.refreshBackToTop) {
                //保留你的调用 + 增强 scroll 事件触发稳定性
             //   window.refreshBackToTop();
             //   setTimeout(() => window.dispatchEvent(new Event('scroll')), 50);
             // }
              
              
              // 手动触发 scroll 事件，确保组件状态更新（某些场景不触发 scroll）
              window.dispatchEvent(new Event('scroll'));
              
              
            }
  
            menuContainer._lastOpenState = isMenuOpen;
          }
        }
      });
    });
  
    // 监听菜单开关class变化
    observer.observe(menuContainer, {
      attributes: true,
      attributeFilter: ['class']
    });
  
    menuContainer._lastOpenState = menuContainer.classList.contains('menu-opening');

  
});





